
export default {
  props: {
    accessories: {
      type: Array,
      required: true,
    },
  },
}
